// Version 1.0.1 canvas-color-tracker - https://github.com/vasturiano/canvas-color-tracker
!function (t, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define(r) : t.ColorTracker = r();
}(this, function () {
  "use strict";

  var a = function a(t, r) {
    if (Array.isArray(t)) return t;
    if (Symbol.iterator in Object(t)) return function (t, r) {
      var e = [],
          n = !0,
          i = !1,
          o = void 0;

      try {
        for (var s, u = t[Symbol.iterator](); !(n = (s = u.next()).done) && (e.push(s.value), !r || e.length !== r); n = !0) {
          ;
        }
      } catch (t) {
        i = !0, o = t;
      } finally {
        try {
          !n && u.return && u.return();
        } finally {
          if (i) throw o;
        }
      }

      return e;
    }(t, r);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  },
      t = function () {
    function n(t, r) {
      for (var e = 0; e < r.length; e++) {
        var n = r[e];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    return function (t, r, e) {
      return r && n(t.prototype, r), e && n(t, e), t;
    };
  }();

  var c = function c(t, r) {
    return 123 * t % Math.pow(2, r);
  };

  return function () {
    function r() {
      var t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : 6;
      !function (t, r) {
        if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
      }(this, r), this.csBits = t, this.registry = ["__reserved for background__"];
    }

    return t(r, [{
      key: "register",
      value: function value(t) {
        if (this.registry.length >= Math.pow(2, 24 - this.csBits)) return null;
        var r,
            e = this.registry.length,
            n = c(e, this.csBits),
            i = (r = e + (n << 24 - this.csBits), "#" + Math.min(r, Math.pow(2, 24)).toString(16).padStart(6, "0"));
        return this.registry.push(t), i;
      }
    }, {
      key: "lookup",
      value: function value(t) {
        var r = a(t, 3),
            e = r[0],
            n = r[1],
            i = r[2],
            o = (e << 16) + (n << 8) + i;
        if (!o) return null;
        var s = o & Math.pow(2, 24 - this.csBits) - 1,
            u = o >> 24 - this.csBits & Math.pow(2, this.csBits) - 1;
        return c(s, this.csBits) !== u || s >= this.registry.length ? null : this.registry[s];
      }
    }]), r;
  }();
});